"use strict";

var _interopRequireDefault = require("/app/node_modules/@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getData = getData;
exports.searchData = searchData;

require("core-js/modules/es.array.concat.js");

var _ApiUtils = require("@/utils/ApiUtils");

var _axios = _interopRequireDefault(require("axios"));

var PROFESIONES_URL = process.env.VUE_APP_CONSULTAS_URL + '/profesion';

function getData(idAgrupacion) {
  var promise = _axios.default.get("".concat(PROFESIONES_URL, "?agrupacion=").concat(idAgrupacion)).catch(function (error) {
    return (0, _ApiUtils.mapError)(error);
  }); // using .then, create a new promise which extracts the data


  var dataPromise = promise.then(function (response) {
    return response === null || response === void 0 ? void 0 : response.data;
  }); // return it

  return dataPromise;
}

function searchData(query) {
  var promise = _axios.default.get("".concat(PROFESIONES_URL, "/search").concat(query, "&sort=descripcion,asc")).catch(function (error) {
    return (0, _ApiUtils.mapError)(error);
  });

  return promise.then(function (response) {
    return response === null || response === void 0 ? void 0 : response.data;
  });
}